
import androidHome from '@/components/jm/android/home.vue'

//设备日志
import androidMacLogHome from '@/components/jm/android/macLog/home.vue'
import androidMacLogList from '@/components/jm/android/macLog/list.vue'
//设备日志文件
import androidFileLogHome from '@/components/jm/android/fileLog/home.vue'
import androidFileLogList from '@/components/jm/android/fileLog/list.vue'

//设备标识
import androidUuidHome from '@/components/jm/android/uuid/home.vue'
import androidUuidList from '@/components/jm/android/uuid/list.vue'
//app 版本管理
import appVersionsHome from '@/components/jm/android/versions/home.vue'
import appVersionsList1 from '@/components/jm/android/versions/list1.vue'
import appVersionsList2 from '@/components/jm/android/versions/list2.vue'
import appVersionsAdd from '@/components/jm/android/versions/add.vue'
import appVersionsUpdate from '@/components/jm/android/versions/update.vue'
export default [{
	path: 'android',
	name: 'android',
	component: androidHome,
	children: [{ //app版本管理
		path: 'androidMacLogHome',
		name: 'androidMacLogHome',
		component: androidMacLogHome,
		children: [{
			path: 'list',
			name: 'jm/android/maclog/list',
			component: androidMacLogList
		}]
	},{ //app版本管理
		path: 'androidUuidHome',
		name: 'androidUuidHome',
		component: androidUuidHome,
		children: [{
			path: 'list',
			name: 'jm/android/uuid/list',
			component: androidUuidList
		}]
	},{ //日志文件管理
		path: 'androidFileHome',
		name: 'androidFileHome',
		component: androidFileLogHome,
		children: [{
			path: 'list',
			name: 'jm/android/filelog/list',
			component: androidFileLogList
		}]
	},{ //app版本管理
		path: 'appVersionsHome',
		name: 'appVersionsHome',
		component: appVersionsHome,
		children: [{
			path: 'list1',
			name: 'jm/android/appVersions/list1',
			component: appVersionsList1
		},{
			path: 'list2',
			name: 'jm/android/appVersions/list2',
			component: appVersionsList2
		}, {
			path: 'add',
			name: 'jm/android/appVersions/add',
			component: appVersionsAdd
		}, {
			path: 'update',
			name: 'jm/android/appVersions/update',
			component: appVersionsUpdate
		}]
	}]
}]



// WEBPACK FOOTER //
// ./src/router/jm/android/android.js